import getDateObject from '@stencil/flights-date-utils/src/get-date-object';

export const UPDATE_SEARCH_WIDGET_DATA = 'UPDATE_SEARCH_WIDGET_DATA';
export const UPDATE_TEMP_SEARCH_WIDGET_DATA = 'UPDATE_TEMP_SEARCH_WIDGET_DATA';
export const UPDATE_OFFER_DATA = 'UPDATE_OFFER_DATA';
export const UPDATE_OUR_PROMISES_AND_USER_STORIES_DATA =
  'UPDATE_OUR_PROMISES_AND_USER_STORIES_DATA';
export const UPDATE_RECENT_SEARCH_DATA = 'UPDATE_RECENT_SEARCH_DATA';
export const UPDATE_HOME_SEO_DATA = 'UPDATE_HOME_SEO_DATA';
export const APPLY_NON_STOP_FILTER = 'APPLY_NON_STOP_FILTER';
export const APPLY_NON_STOP_RETURN_FILTER = 'APPLY_NON_STOP_RETURN_FILTER';
export const SET_HISTORY_LISTENING = 'SET_HISTORY_LISTENING';
export const SET_EXPERIMENT_DETAILS = 'SET_EXPERIMENT_DETAILS';
export const SET_EXPERIMENT_META_DATA = 'SET_EXPERIMENT_META_DATA';
export const SET_EXPERIMENT_VARIANT_KEY = 'SET_EXPERIMENT_VARIANT_KEY';
export const UPDATE_SEARCH_RESULT = 'UPDATE_SEARCH_RESULT';
export const SET_FARE_OPTIONS_INFO = 'SET_FARE_OPTIONS_INFO';
export const SET_IS_FARE_OPTIONS_RECEIVED = 'SET_IS_FARE_OPTIONS_RECEIVED';
export const SET_SELECTED_FARE_OPTION = 'SET_SELECTED_FARE_OPTION';
export const SET_HIT_EXPERIMENT_DETAILS = 'SET_HIT_EXPERIMENT_DETAILS';
export const SET_MWEB_TO_APP_SECTORS = 'SET_MWEB_TO_APP_SECTORS';
export const SET_UUID = 'SET_UUID';
export const SET_SSR = 'SET_SSR';
export const SET_IS_MODIFY_SEARCH_OPEN_IN_SRP = 'SET_IS_MODIFY_SEARCH_OPEN_IN_SRP';
export const SET_HOLIDAY_INFO = 'SET_HOLIDAY_INFO';
export const SET_HOME_OMNITURE_INFO = 'SET_HOME_OMNITURE_INFO';
export const UPDATE_EASY_VISA_DESTINATIONS = 'UPDATE_EASY_VISA_DESTINATIONS';
export const UPDATE_FLAVOUR = 'UPDATE_FLAVOUR';

export const flightClassList = {
  E: 'Economy',
  B: 'Business',
  F: 'First class',
  W: 'Premium Economy'
};

export function updateSearchWidgetData(searchWidgetData) {
  const arrival = searchWidgetData.arrival;
  const departure = searchWidgetData.departure;
  return {
    type: UPDATE_SEARCH_WIDGET_DATA,
    props: {
      ...searchWidgetData,
      ...(arrival ? { arrival: arrival?.dateObj ? arrival : getDateObject(arrival) } : null),
      ...(departure
        ? { departure: departure?.dateObj ? departure : getDateObject(departure) }
        : null)
    }
  };
}

export function updateTempSearchWidgetData(searchWidgetData) {
  const arrival = searchWidgetData.arrival;
  const departure = searchWidgetData.departure;
  return {
    type: UPDATE_TEMP_SEARCH_WIDGET_DATA,
    props: {
      ...searchWidgetData,
      ...(arrival ? { arrival: arrival?.dateObj ? arrival : getDateObject(arrival) } : null),
      ...(departure
        ? { departure: departure?.dateObj ? departure : getDateObject(departure) }
        : null)
    }
  };
}

export function updateFlavour(flavour) {
  return {
    type: UPDATE_FLAVOUR,
    props: { flavour }
  };
}

export function updateOfferData(offersData) {
  return {
    type: UPDATE_OFFER_DATA,
    props: { offersData }
  };
}

export function updateOurPromisesAndUserStoriesData(actionData) {
  return {
    type: UPDATE_OUR_PROMISES_AND_USER_STORIES_DATA,
    props: {
      ourPromises: actionData?.our_promises || {},
      userStories: actionData?.user_stories || {}
    }
  };
}

export function updateRecentSearchData(recentSearchData) {
  if (recentSearchData.length) {
    const item = recentSearchData[0];
    return {
      type: UPDATE_RECENT_SEARCH_DATA,
      props: {
        recentSearchData,
        source: item.source,
        destination: item.destination,
        departure: getDateObject(item.departure),
        arrival: item.arrival ? getDateObject(item.arrival) : null,
        passengers: item.passengers,
        flightClass: item.flightClass,
        journeyType: item.journeyType,
        travelType: item.travelType
      }
    };
  }
  return {
    type: UPDATE_RECENT_SEARCH_DATA,
    props: { recentSearchData }
  };
}

export function updateSEOData(homeSeoData) {
  return {
    type: UPDATE_HOME_SEO_DATA,
    props: { homeSeoData }
  };
}

export const setHistoryListening = actionData => {
  return {
    type: SET_HISTORY_LISTENING,
    props: {
      isHistoryListening: actionData
    }
  };
};

export const setExperimentDetails = actionData => {
  return {
    type: SET_EXPERIMENT_DETAILS,
    props: actionData
  };
};

export const setExperimentMetaData = actionData => {
  return {
    type: SET_EXPERIMENT_META_DATA,
    props: actionData
  };
};

export const setExperimentVariantKey = actionData => {
  return {
    type: SET_EXPERIMENT_VARIANT_KEY,
    props: actionData
  };
};

export const setUpdateSearchResult = actionData => {
  return {
    type: UPDATE_SEARCH_RESULT,
    props: {
      updateSearchResult: actionData
    }
  };
};

export const setFareOptionsInfo = actionData => {
  return {
    type: SET_FARE_OPTIONS_INFO,
    props: {
      fareOptionsInfo: actionData
    }
  };
};

export const setIsFareOptionsReceived = actionData => {
  return {
    type: SET_IS_FARE_OPTIONS_RECEIVED,
    props: {
      isFareOptionsReceived: actionData
    }
  };
};

export const setMwebToAppSectors = actionData => {
  return {
    type: SET_MWEB_TO_APP_SECTORS,
    props: {
      mwebToAppSectors: actionData
    }
  };
};

export const setSelectedFareOption = actionData => {
  return {
    type: SET_SELECTED_FARE_OPTION,
    props: {
      selectedFareOptionInfo: actionData
    }
  };
};

export const setHitExperimentDetails = actionData => {
  return {
    type: SET_HIT_EXPERIMENT_DETAILS,
    props: {
      hitExperimentDetails: actionData
    }
  };
};

export function setUUID(uuid) {
  return {
    type: SET_UUID,
    props: { uuid }
  };
}

export function setSSR(ssr) {
  return {
    type: SET_SSR,
    props: { ssr }
  };
}

export const setModifySearchOpenInSRP = actionData => {
  return {
    type: SET_IS_MODIFY_SEARCH_OPEN_IN_SRP,
    props: {
      isModifySearchOpenInSRP: actionData
    }
  };
};

export const setHolidayInfo = actionData => {
  const holidayInfo = actionData;
  if (holidayInfo && holidayInfo?.holidays?.holidayList) {
    const holidayList = holidayInfo?.holidays?.holidayList;
    const holidayObj = {};
    holidayList.map(holiday => {
      holidayObj[holiday.date.split('-').join('')] = holiday;
    });
    holidayInfo.holidays.holidayList = holidayObj;
  }
  return {
    type: SET_HOLIDAY_INFO,
    props: {
      holidayInfo
    }
  };
};

export const setHomeOmnitureInfo = omnitureInfo => {
  return {
    type: SET_HOME_OMNITURE_INFO,
    props: { homeOmnitureInfo: omnitureInfo }
  };
};

export const setEasyVisaDestinations = easyVisaDestinationData => {
  return {
    type: UPDATE_EASY_VISA_DESTINATIONS,
    props: { easyVisaDestinationData }
  };
};
